import { render, staticRenderFns } from "./Region2.vue?vue&type=template&id=368625b0&"
import script from "./Region2.vue?vue&type=script&lang=js&"
export * from "./Region2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports